import React, { Ref } from 'react'
import { CurrencyInput } from '@paypalcorp/pp-react'
import { useLocalizedContent } from '../../../hooks/useLocalizedContent'
import { useAppSelector } from '../../../store/hooks'
import { selectGoalAmount } from '../../../store/slices/groupFormSlice'

interface GoalAmountProps {
  error?: string
  handleOnChange: Function
  currencyCode?: string
  goalAmountRef?: Ref<HTMLInputElement>
}

const GroupGoalAmount = (props: GoalAmountProps) => {
  const goalAmount = useAppSelector(selectGoalAmount)
  const { getContent } = useLocalizedContent()

  const handleAccept = (
    _value: string,
    unmaskedValue: string,
    _typedValue: string,
  ) => {
    props.handleOnChange(unmaskedValue)
  }

  return (
    <CurrencyInput
      name="goalAmount"
      label={getContent('create.view.goalLabel')}
      onAccept={handleAccept}
      value={goalAmount}
      currencyType={props.currencyCode}
      data-testid="group-goal-amount-input"
      errorText={props.error}
      ref={props.goalAmountRef}
    />
  )
}
export default GroupGoalAmount
